import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { TypographyComponent } from '../typography/typography.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hyperkit-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  standalone: true,
  imports: [TypographyComponent, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent implements OnChanges {
  @Input() public text = '';
  @Input() public position: 'top' | 'right' | 'bottom' | 'left' = 'top';
  @Input() public variant: 'dark' | 'light' = 'dark';
  @Input() public tip: 'top' | 'bottom' | 'center' | 'left' | 'right' =
    'center';

  public isVisible: boolean = false;

  public showTooltip(): void {
    this.isVisible = true;
  }

  public hideTooltip(): void {
    this.isVisible = false;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['position'] || changes['tip']) {
      this.validateInputs();
    }
  }

  private validateInputs(): void {
    const validTipForPosition = {
      top: ['left', 'right', 'center'],
      bottom: ['left', 'right', 'center'],
      left: ['top', 'bottom', 'center'],
      right: ['top', 'bottom', 'center'],
    };

    if (!validTipForPosition[this.position].includes(this.tip)) {
      console.warn(
        `Invalid combination: position "${this.position}" and tip "${this.tip}". Resetting tip to "center".`,
      );
      this.tip = 'center';
    }
  }
}
